import React, {forwardRef} from "react";
import {
    AddBox, ArrowDownward,
    Check, ChevronLeft,
    ChevronRight,
    Clear,
    DeleteOutline,
    Edit,
    FilterList,
    FirstPage, LastPage, Remove,
    SaveAlt, Search, ViewColumn
} from "@material-ui/icons";
import MaterialTable from "@material-table/core";
import EditIcon  from '../../../assets/Edit.svg';
import DeleteIcon from '../../../assets/Delete.svg';

const MaterialUiTable = ({data, columns, title, onClickEdit, onClickDelete}) => {
    const tableIcons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref}/>),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref}/>),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref}/>),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref}/>),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}/>),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref}/>),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref}/>),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref}/>),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref}/>),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref}/>),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}/>),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref}/>),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref}/>),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref}/>),
        SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref}/>),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref}/>),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref}/>)
    };

    const actions = [
        {
            icon: () => <img style={{marginLeft: '5px', marginRight: '5px'}} src={EditIcon}/>,
            onClick: (event, rowData) => onClickEdit(rowData),
            tooltip: 'Edit'
        },
        {
            icon: () => <img style={{marginLeft: '5px', marginRight: '5px'}} src={DeleteIcon}/>,
            onClick: (event, rowData) => onClickDelete(rowData),
            tooltip: 'Delete'
        }]

    const options = {
        actionsColumnIndex: -1,
        pageSize: 10,
        actionsCellStyle: {
            fontFamily: 'Inter-SemiBold',
            fontSize: '12px',
            color: '#0A1F44',
            textTransform: 'capitalize'
        },
        headerStyle: {
            fontFamily: 'Inter-SemiBold',
            fontSize: '12px',
            color: '#0A1F44'
        }
    }

    const localization = {
        header: {
            actions: 'ACTIONS'
        }
    }

    return (
        <MaterialTable columns={columns} data={data} title={title} icons={tableIcons} actions={actions} options={options}
                       localization={localization}/>
    );
};

export default MaterialUiTable;
